import debounce from 'lodash/debounce';
import React, { useCallback, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FormattedMessage } from 'react-intl';
import { renderSearchTabs } from '../../util/circleHelper';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import Modal from '../Modal/Modal';
import SearchInGroupPostCard from '../SearchInGroupCard/SearchInGroupPostCard';
import css from './SearchInGroupModal.module.css';
import { createResourceLocatorString } from '../../util/routes';
import IconSearch from '../IconSearch/IconSearch';
import { IconSpinner } from '..';

const SearchInGroupModal = props => {
  const {
    onManageDisableScrolling,
    isSearchInModal = false,
    onToggelSearchInGroup,
    onGroupPostSearch,
    spaceId,
    groupPostSearchInProgress,
    groupPostSearchData,
    history,
    routeConfiguration
  } = props;
  const [keyword, setKeyword] = useState('');
  const [isActiveTab, setActiveTab] = useState(renderSearchTabs[0]?.id);

  const { has_next_page = false, page = 1, per_page = 10, records = [], type = 'posts' } =
    groupPostSearchData ?? {};

  const debouncedSearch = useCallback(
    debounce(value => {
      onGroupPostSearch({ query: value, spaceId: spaceId, type: isActiveTab });
    }, 500),
    [isActiveTab, spaceId]
  );

  const handleSearchInGroup = event => {
    const value = event.target.value;
    setKeyword(value);
    debouncedSearch.cancel();
    if (!keyword) return
    debouncedSearch(value);
  };

  const handleLoadMore = () => {
    const params = {
      page: page + 1,
      per_page: 10,
      query: keyword,
      spaceId: spaceId,
      type: isActiveTab,
    };
    if(!keyword) return
    onGroupPostSearch(params);
  };

  const handleTabSwitch = tabId => {
    setActiveTab(tabId);
    if(!keyword) return
    onGroupPostSearch({ query: keyword, spaceId: spaceId, type: tabId });
  };

  const handleCloseModal = () => {
    onToggelSearchInGroup(false);
    setKeyword('');
    setActiveTab(renderSearchTabs[0]?.id);
  };

  const handleSearchItemClick = (record) => {
    const {space_slug, slug , id, post_id } = record ?? {}

    handleCloseModal()
    return history.push(
      createResourceLocatorString('PostViewPage', routeConfiguration, {
        spaceId,
        slug: slug ?? space_slug,
        postId:  post_id ? post_id : id,
      },
      post_id ? { commentId: id } : {}
      )
    );
  };

  return (
    <Modal
      id="searchInGroupModal"
      isOpen={isSearchInModal}
      onClose={handleCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      className={css.memberListMmodal}
    >
      <div className={css.topWrapper}>
        {/* render comment and posts tabs */}
          <>
            <input onChange={handleSearchInGroup} placeholder="Search in Group" value={keyword} />
            <div className={css.scrollSection} id="scrollableDiv">
              <div className={css.contentWrapper}>
                <div className={css.tabsContaniner}>
                  {renderSearchTabs.map((tab, index) => (
                    <div
                      className={isActiveTab == tab.id ? css.activeTab : css.inactiveTab}
                      key={tab.id}
                      onClick={() => handleTabSwitch(tab.id)}
                    >
                      {tab.name}
                    </div>
                  ))}
                </div>

                {groupPostSearchData && !records.length ? (
                  <div className={css.noresultDescription}>
                    <div className={css.noresultTitle}>
                    <FormattedMessage
                      id="SearchInGroup.noSearchResultTitle"
                      values={{ tabName: isActiveTab }}
                    />
                    </div>
                    <FormattedMessage id="SearchInGroup.noSearchResultDescription" />
                  </div>
                ) : null}
                {!keyword ? (
                  <div className={css.noresultDescription}>
                    <IconSearch />
                    <div className={css.noresultTitle}>
                    <FormattedMessage id="SearchInGroup.searchTitle" />
                    </div>
                    <FormattedMessage id="SearchInGroup.searchDescription" />
                  </div>
                ) : null}
                {groupPostSearchInProgress ? <div className={css.spinnerWrapper}><IconSpinner /> </div>: null}

                {(keyword && !groupPostSearchInProgress) ? <div>
                  <InfiniteScroll
                    hasMore={has_next_page}
                    next={handleLoadMore}
                    dataLength={(records && records.length) || per_page}
                    scrollableTarget="scrollableDiv"
                  >
                    {records && records.length
                      ? records?.map((record, index) => (
                          <ErrorBoundary key={'errorBoundry-' + index}>
                            <SearchInGroupPostCard
                              record={record}
                              handleSearchItemClick={handleSearchItemClick}
                            />
                          </ErrorBoundary>
                        ))
                      : null}
                  </InfiniteScroll>
                </div> : null}
              </div>
            </div>
          </>
      </div>
    </Modal>
  );
};

export default SearchInGroupModal;
